import { render, staticRenderFns } from "./ChooseTimelineStructureModal.vue?vue&type=template&id=2956cbec&scoped=true"
import script from "./ChooseTimelineStructureModal.vue?vue&type=script&lang=js"
export * from "./ChooseTimelineStructureModal.vue?vue&type=script&lang=js"
import style0 from "./ChooseTimelineStructureModal.vue?vue&type=style&index=0&id=2956cbec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2956cbec",
  null
  
)

export default component.exports